var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.0155 28.141L40.0004 1.22363L0.986328 28.141V76.6219C0.986328 76.9319 1.04549 77.2389 1.16039 77.5253C1.27529 77.8116 1.44369 78.0718 1.65599 78.291C1.8683 78.5101 2.12034 78.6839 2.39771 78.8025C2.67508 78.921 2.97235 78.9819 3.27253 78.9818H76.7332C77.3393 78.9818 77.9205 78.7332 78.3491 78.2906C78.7777 77.848 79.0184 77.2478 79.0184 76.6219L79.0155 28.141Z",
    stroke: "#02022C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2012 49.3994L37.9195 54.5364C38.5636 54.8771 39.277 55.0547 40.0007 55.0547C40.7244 55.0547 41.4377 54.8771 42.0819 54.5364L51.8002 49.3994",
    stroke: "#02022C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9722 38.5817V22.7881H20.0278L19.1094 37.4684L39.6831 48.642",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9722 38.5817V22.7881H20.0278L19.1094 37.4684L39.6831 48.642",
    stroke: "#5FB527",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.709 30.2383H51.293",
    stroke: "#5FB527",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.709 36.3662H51.293",
    stroke: "#5FB527",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0155 28.1406L40.0004 48.769L0.986328 28.1447",
    stroke: "#02022C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.076cab495ba7e876e69a14bbb21abc51.svg";
export { ForwardRef as ReactComponent };